/* eslint-disable max-len */
const ExternalLinks = {
    CAP_ONE: 'https://www.capitalone.co.uk',
    LEGAL: 'https://www.capitalone.co.uk/compliance/legal-information',
    COOKIES: 'https://www.capitalone.co.uk/compliance/cookie-policy',
    ACCESSIBILITY: 'https://www.capitalone.co.uk/support/accessibility',
    CONTACT: 'https://www.capitalone.co.uk/support/contact-us',
    PRIVACY_POLICY: 'https://www.capitalone.co.uk/compliance/privacy-policy',
    CREDITWISE_REGISTRATION: 'https://creditwise.capitalone.co.uk/registration?vc=DEC',
    EQUIFAX: 'https://www.equifax.co.uk/',
    TRANSUNION: 'https://www.transunion.co.uk/crain',
    EXPERIAN: 'https://www.experian.co.uk/',
    CREDIT_MADE_CLEARER: 'https://www.capitalone.co.uk/creditmadeclearer',
    QUICKCHECK: 'https://quickcheck.capitalone.co.uk',
    MONEY_HELPER_GUIDE:
        'https://www.moneyhelper.org.uk/en/everyday-money/credit/what-to-do-if-you-have-been-refused-a-loan-or-credit-card',
    MONEY_HELPER_CHECK_CREDIT_SCORE:
        'https://www.moneyhelper.org.uk/en/everyday-money/credit/how-to-check-your-credit-report',
    DATA_ONE_WEBSITE: 'https://www.data.one/',
    DATA_ONE_TERMS: 'https://www.data.one/terms',
    DATA_ONE_PRIVACY_POLICY: 'https://www.data.one/privacy',
    ASOS: 'https://www.asos.com'
};

const content = {
    AlreadyAppliedDecline: {
        Title: "Hey {{NAME}}, you've already applied for one of our cards",
        Paragraph1:
            "Thanks for applying. It looks like you've already got a previous application being processed with us, or one of our partner credit cards.",
        Paragraph2: "You can find out what's happening with your existing application by {{CONTACT}}",
        ContactUs: 'contacting us.',
        ContactUsLink: ExternalLinks.CONTACT,
        HomePage: 'Homepage',
        HomePageLink: ExternalLinks.CAP_ONE
    },
    OpenBankingLanding: {
        Title: 'We need more information',
        PtdTitle: 'You’re not eligible for that card, but you might be for a different one',
        ObLandingHeading: 'See if it’s a yes by linking your bank account',
        EligibilityCheckTitle: 'Link your bank account to check if you’re eligible',
        Subtitle: 'You choose which bank accounts you link to. It’s quick, easy, and we’ll never share your data.',
        MSMTitle: 'Link the bank where you get paid to check if you’re eligible',
        MSMSubtitle1: 'Connecting the bank account you’re paid into helps us make a decision.',
        MSMSubtitle2: 'It’s quick, easy, and we’ll never share your data.',
        OceanSubtitle1: 'Sharing your banking history can help make a decision.',
        OceanSubtitle2: 'It’s only a few simple steps.',
        OceanSubtitle3:
            'You choose which bank accounts you link to. It’s quick, easy, and your data will never be shared.',
        Accordion1:
            'When you do a QuickCheck, we make a decision based on the info you’ve provided. In some cases, we might need to know a little more before offering you a card. This is where Open Banking comes in.',
        EligibilityCheckAccordion1:
            'When you do an eligibility check, we make a decision based on the info you’ve provided. In some cases, we might need to know a little more first. This is where Open Banking comes in.',
        OceanAccordion1:
            'While we help match you to the right card, when you do an eligibility check, it’s Capital One that makes a decision based on the info you’ve provided. In some cases, they might need to know a little more first. This is where Open Banking comes in.',
        Accordion2:
            'With Open Banking, you can share your banking history with us. We can use a snapshot of your balances and transactions from the last 12 months to help us make a decision.',
        AreYouSureModal: "We won't be able to offer you a card if you don't link your bank account.",
        LinkMyBankAccount: 'Link my bank account',
        ObLandingCardAccordion: {
            LinkYourBankAccount: {
                Heading: 'Link your bank account',
                Body: 'You choose which bank accounts you link to. It’s quick, easy, and we’ll never share your data.'
            },
            GetAStraightYesOrNo: {
                Heading: 'Get a straight yes or no',
                Body: 'We take a snapshot of your balances and transactions from the last 12 months to help us make a decision.'
            }
        },
        HomePageLink: ExternalLinks.CAP_ONE,
        DOneText: {
            Link1: {
                Text: 'learn about D.One'
            },
            Link2: {
                Text: 'read our privacy policy',
                Target: ExternalLinks.PRIVACY_POLICY
            }
        },
        AboutDOneModalTextParagraph1: {
            Link1: {
                Text: 'https://www.data.one',
                Target: ExternalLinks.DATA_ONE_WEBSITE
            }
        },
        DOneModal2:
            'D•One will redirect you to your selected bank or payment services provider where you will authenticate yourself, and consent to D•One accessing your account information for the purposes of securely sharing that information to us.',
        AboutDOneModalTextParagraph3: {
            Link1: {
                Text: 'https://www.data.one/terms',
                Target: ExternalLinks.DATA_ONE_TERMS
            },
            Link2: {
                Text: 'https://www.data.one/privacy',
                Target: ExternalLinks.DATA_ONE_PRIVACY_POLICY
            }
        },
        DOneModal4:
            'D•One is a trading name of Money Dashboard Limited, authorised by the UK Financial Conduct Authority to provide account information services (Firm Reference Number: 800652).'
    },
    HowDoesItWork: {
        Paragraph1:
            "When you do an eligibility check, we decide whether to offer you a card based on the questions you've answered.",
        Paragraph2:
            'With Open Banking, you can share your banking history to give us a better picture of your finances. We can use a snapshot of your balances and transactions from the last 12 months to help us make a decision.',
        Paragraph3:
            'Want to know more? You can {{DONE_LINK}} (our Open Banking partner), or read {{PRIVACY_POLICY_LINK}}.',
        DOneLink: {
            Text: 'learn about D•One',
            Target: ExternalLinks.DATA_ONE_WEBSITE
        },
        PrivacyPolicyLink: {
            Text: 'our privacy policy',
            Target: ExternalLinks.PRIVACY_POLICY
        }
    },
    OpenBankingPostSubmitModal: {
        Heading: 'Share your banking history to help us make a decision?',
        Body: 'You can choose which bank accounts you link to on the next step. It’s quick, easy, and we’d never share your data.',
        Accordion: 'How does it work?',
        LinkMyBankAccount: 'Link my bank account',
        NoThanksSkip: 'No thanks, skip'
    },
    TechnicalError: {
        Heading: 'Oops, something went wrong',
        Body: 'You can try QuickCheck again later or go to our homepage to find out more about Capital One and our credit cards.',
        MSMBody:
            'Go back to MoneySuperMarket to try again, or capitalone.co.uk to find out more about us and our credit cards.'
    },
    TimedOut: {
        Title: 'Your session has timed out',
        Paragraph1: 'Sorry about that. QuickCheck was inactive for a while, so we closed it to keep your details safe.',
        Paragraph2: 'Please start QuickCheck again to see if you’re eligible for a credit card.',
        Button: {
            Text: 'Start QuickCheck'
        }
    },
    Spinner: {
        Title: "We're checking your details"
    },
    ObRedirectSpinner: {
        Title: 'Taking you to D•One'
    },
    ScoreDecline: {
        HowDidWeDecideThis: {
            Heading: 'How did we decide this?',
            Body: {
                Copy: "We can't go into too much detail on why we said no today, but we used data from the credit reference agencies ({{EXPERIAN}}, {{EQUIFAX}}) to make a decision.",
                Equifax: {
                    Text: 'Equifax',
                    Target: ExternalLinks.EQUIFAX
                },
                Experian: {
                    Text: 'Experian',
                    Target: ExternalLinks.EXPERIAN
                }
            }
        },
        WhatWeLookAt: {
            Heading: 'A few things we looked at...',
            Points: {
                Point1: {
                    Body: "How much you're borrowing right now"
                },
                Point2: {
                    Body: "If you've managed credit well in the past"
                },
                Point3: {
                    Body: 'Your credit rating at the moment'
                },
                Point4: {
                    Body: "If you've struggled with debt recently"
                }
            }
        },
        WhatCanYouDo: {
            Heading: 'What can you do next?',
            CreditScore: {
                Heading: 'Check your credit report for free',
                Body: 'Tools like our very own CreditWise can help you understand your credit score and find out what you could be doing better.',
                Button: {
                    Text: 'Go to CreditWise',
                    GuideLink: ExternalLinks.CREDITWISE_REGISTRATION
                }
            },
            MoneyHelperCapOne: {
                Heading: 'Get money tips and advice',
                Body: `MoneyHelper can support with all things finance. Whether it's credit, budgeting, debt, or anything else.`,
                Button: {
                    Text: 'Go to MoneyHelper',
                    GuideLink: ExternalLinks.MONEY_HELPER_GUIDE
                }
            },
            MoneyHelperPartners: {
                Heading: 'Check your credit report for free',
                Body: `MoneyHelper has links to all the credit reference agencies we use to make a decision. You'll be able to see what the lenders see, and find out where you could be making improvements.`,
                Button1: {
                    Text: 'Check my credit report',
                    GuideLink: ExternalLinks.MONEY_HELPER_CHECK_CREDIT_SCORE
                },
                Button2: {
                    Text: 'More about MoneyHelper',
                    GuideLink: ExternalLinks.MONEY_HELPER_GUIDE
                }
            }
        }
    },
    InformationMismatch: {
        Title: "We can't find your information",
        Playback: {
            Preamble:
                "We can't lend to you because the information you have given doesn't match the information with the credit reference agencies. Read the following and this could change.",
            Heading: 'Are your details correct?',
            FullNameHeading: 'Full Name',
            DateOfBirthHeading: 'Date of Birth',
            YourWorkHeading: 'Your work',
            AddressHeading: 'Address',
            YearsAtAddressHeading: 'Years at address',
            Body: 'If the information is incorrect, simply change your details in QuickCheck.',
            CTA: {
                Text: 'Change your details',
                Target: ExternalLinks.QUICKCHECK
            }
        },
        GetInTouch: {
            Body: '{{GET_IN_TOUCH_LINK}} with us if you have any additional questions.',
            Link: {
                Text: 'Get in touch',
                Target: ExternalLinks.CONTACT
            }
        }
    },
    CheckYourCreditFile: {
        Heading: 'Check your credit file',
        Body1: "Okay, so you've checked your details and they're correct. Here's what you need to do next:",
        Points: {
            Point1: 'Contact the credit reference agencies',
            Point2: 'Check the details they have about you',
            Point3: "Update anything that's incorrect",
            Point4: 'Come back to QuickCheck'
        },
        Body2: {
            Text: 'We use {{EQUIFAX}}, {{TRANSUNION}} and {{EXPERIAN}} to compare your details so by signing up with them you can check your details are correct (some may charge a small fee).',
            Equifax: {
                Text: 'Equifax',
                Target: ExternalLinks.EQUIFAX
            },
            Transunion: {
                Text: 'Transunion',
                Target: ExternalLinks.TRANSUNION
            },
            Experian: {
                Text: 'Experian',
                Target: ExternalLinks.EXPERIAN
            }
        }
    },
    DatePicker: {
        Day: 'Day',
        Month: 'Month',
        Year: 'Year'
    },
    DocumentHead: {
        Title: 'Which credit card is right for you? - Capital One',
        Description: "Fill in your details to check if you'll be accepted. Won't affect your credit rating."
    },
    Header: {
        Link: ExternalLinks.CAP_ONE,
        AriaLabel: 'Capital One home page'
    },
    Hero: {
        feature1: 'Response in 60 seconds',
        feature2: "Won't affect your credit rating",
        feature3: '100% certainty before you apply',
        FeatureOne: {
            Icon: 'Stopwatch',
            Header: 'Quick and easy',
            Text1: 'QuickCheck is easy to use and provides a fast, no risk answer to the question, "Will I be approved for a credit card?" Try QuickCheck to check your eligibility now.'
        },
        FeatureTwo: {
            Icon: 'ProtectionFinance',
            Header: "We won't affect your credit rating",
            Text1: "We think it's responsible to tell you whether you will be approved for a card before you apply. By working with credit reference agencies we do a pre-application check of your credit rating using QuickCheck.",
            Text2: "You'll be able to see the search on your file, but it won't show up to other organisations. This means there is no impact to your credit rating."
        },
        FeatureThree: {
            Icon: 'ThumbsUp',
            Header: 'Apply with confidence',
            Text1: 'If you decide to apply for a card you can apply with confidence knowing you will be accepted, at which point we do a visible update to the credit reference agencies to let them know you asked us for credit.',
            Text2: "We stand behind our answer and confirm that we've carried out all the appropriate credit checks we need. However, there is a small chance that we may be unable to open your account if we identify certain information on fraud prevention databases or if we are not able to verify your identity."
        },
        InstantIssuanceHero: {
            feature1: 'No impact on your credit score',
            feature2: '100% certainty before you apply',
            feature3: 'Use your card before it arrives',
            FeatureOne: {
                Icon: 'ProtectionFinance',
                Header: 'No impact on your credit score',
                Text1: 'We think it’s important to tell you if you’ll be approved for a card before you apply. By working with credit reference agencies, we do a pre-application check of your credit rating using QuickCheck.',
                Text2: "You’ll  be able to see the search on your file, but it won't show to anyone else. This means there’s no impact on your credit score."
            },
            FeatureTwo: {
                Icon: 'ThumbsUp',
                Header: '100% certainty before you apply',
                Text1: 'When you use QuickCheck, you can apply for a card with confidence, knowing you’ll get a straight yes or no. If you decide to move forward with a card, we’ll update the credit reference agencies to let them know you asked us for credit.',
                Text2: 'In some rare cases, we won’t be able to set up a card. But that’s usually just if we find information on fraud databases, or if we can’t confirm your identity.'
            },
            FeatureThree: {
                Icon: 'Stopwatch',
                Header: 'Use your card before it arrives',
                Text1: 'To get early access to your card details, you’ll need to download and set up your app straight away after applying.',
                Text2: 'You’ll be able to view your card details in the app, and use them for online purchases while your physical card is on the way. Early access to your card details depends on eligibility and ID checks.'
            }
        }
    },
    NoImpactModal: {
        FeatureTwo: {
            Header: "We won't affect your credit rating",
            Text1: "We think it's responsible to tell you whether you will be approved for a card before you apply. By working with credit reference agencies we do a pre-application check of your credit rating using QuickCheck.",
            Text2: "You’ll  be able to see the search on your file, but it won't show up to other organisations. This means there is no impact to your credit rating."
        }
    },
    QuotationForm: {
        FormTitle: {
            part1: 'Fill in your details ',
            part2: "to check if you'll be accepted"
        },
        EditTitle: 'Edit your details',
        EditHeader:
            'Make changes with no impact on your credit score, then get a fresh yes or no based on your new information.',
        Submission: {
            InProgress: 'Submitting...'
        },
        Wizard: {
            NextButton: {
                Default: 'Continue',
                Start: 'Get started',
                StepNumber: 'Continue to step {{nextStageNumber}}',
                StageTitle: `Continue to '{{stageTitle}}'`,
                PrePop: 'Go to next answer'
            },
            skipEditButton: 'I’ve made my changes',
            PreviousButton: 'Back',
            SubmitButton: 'QuickCheck now'
        },
        NoHarmFeature: 'No impact to your credit score',
        PhoneNumber: {
            ButtonText: 'Add home number (optional)',
            LinkText: 'Add home phone number (optional)'
        },
        Address: {
            LookUp: {
                Label: {
                    PostCode: 'Postcode',
                    PostCodeCurrentAddress: "What's your postcode?",
                    PostCodePreviousAddress: 'What was your postcode before this?',
                    HouseNumber: 'House/flat name or number (optional)'
                },
                Errors: {
                    PostCode: {
                        Required: 'Postcode is required',
                        Invalid: 'This is not a valid Postcode',
                        AddressError: 'Address lookup failed, please enter address manually'
                    },
                    HouseNumber: {
                        maxLength: 'Your House/flat name or number must be less than 32 characters'
                    },
                    PreviousAddress: 'Previous address must be different',
                    LookupAddress: 'Please provide your address'
                },
                FindAddressButton: 'Find address'
            },
            CurrentAddress: {
                Label: 'Your address',
                ListTitle: 'Select your address',
                TimeAtAddressLabel: 'How long have you lived at this address?'
            },
            PreviousAddress: {
                Label: 'Your previous address',
                ListTitle: 'Select your previous address',
                TimeAtAddressLabel: 'How long did you live at this address?'
            },
            LookupAddressLink: 'Or enter address manually',
            ManualAddressLink: 'Or search for your address',
            LoadingMessage: 'Finding your address...'
        },
        Tracker: {
            ActiveStep: 'Step {{index}} - {{title}}',
            FutureStep: 'Step {{index}}'
        },
        SinglePageExperimentTakeControl: 'Take control with an easy to manage card from Capital One'
    },
    ReasonsToQuote: {
        Description1: `Doing a QuickCheck`,
        DescriptionBold: ` won't impact your credit score, `,
        Description2: `and you'll be the only one who can see it on your credit report. We'll also email and text you the results.`,
        Description3: `All we do is pass your info to credit reference agencies to do a pre-application check of your credit rating.`,
        Heading: 'We can keep checking',
        Checkbox: `We'll let you know whether you're eligible for a card in future. This won't affect your credit score. To say no, untick the box.`,
        Instant: `Get a straight yes or no`,
        Impact: `No impact on your credit score`,
        SubmitButton: `QuickCheck now`
    },
    SimpleHeader: {
        Title1: 'Check your eligibility,',
        Title2: `no impact on credit score`,
        PtdTitle1: 'Check your eligibility for a',
        PtdTitle2: '0% Purchase Credit Card',
        PtdNoImpact: 'No impact on your credit score',
        GenericHeader: {
            ReasonText: {
                Header: 'Get a straight yes or no'
            }
        },
        InstantIssuanceHeader: {
            InstantIssuanceBanner: {
                Icon: 'FullCard',
                Header: 'Use your card before it arrives',
                Text1: 'To get early access to your card details, you’ll need to download and set up your app straight away after applying. This will involve taking a quick photo of yourself and either a UK passport or driving licence.',
                Text2: 'After this, you’ll be able to view your card details in the app, and use them for online purchases while your physical card is on the way. Early access to your card details depends on eligibility and ID checks.'
            }
        }
    },
    Stage: {
        BTNoHarm: {
            text1: `Check if we'll approve your transfer amount, with `,
            text2: 'no impact to your credit score.'
        },
        IncomeMessaging: {
            YearlyIncome: {
                Description:
                    'If your income could {{BOLD_TEXT}} in the next 12 months, please enter what you think it will be.'
            },
            OtherHouseHoldIncome: {
                Description:
                    'If your income could {{BOLD_TEXT}} in the next 12 months, please enter what you think it will be.'
            },
            RentMortgagePayment: {
                Title: 'Could your rent or mortgage change soon?',
                Description:
                    'If your rent, mortgage or board could {{BOLD_TEXT}} in the next 12 months, please enter what you think it will be.'
            }
        },
        SubmissionFooter: {
            Text: 'No impact to your credit score'
        },
        SinglePageExperimentApplyHeader: 'One last thing...'
    },
    QuickcheckGuarantee: {
        NoImpact: 'No impact on your credit score'
    },
    TermsAndConditions: {
        Statement: 'Before doing a QuickCheck please read the {{TERMS_AND_CONDITIONS}} and {{PRIVACY_POLICY}}',
        TAndC: 'terms and conditions',
        PrivacyPolicy: 'privacy policy',
        PrivacyPolicyLink: ExternalLinks.PRIVACY_POLICY,
        TermsAndConditionsHeader: 'Capital One QuickCheck Terms and Conditions'
    },
    Modal: {
        CloseButtonAriaLabel: 'Close pop-up',
        Close: 'close'
    },
    TermsAndConditionsModalView: {
        Heading: 'Capital One QuickCheck Terms and Conditions',
        Section1: {
            Heading: '1. About us',
            Paragraph1: `
                    Capital One (Europe) plc is a public limited company registered in England and Wales under company number 3879023.
                    In these terms and conditions, "we", "us" and "our" refers to Capital One (Europe) plc.
                    Our registered office is at Trent House, Station Street, Nottingham, NG2 3HX.
                    We are authorised and regulated by the Financial Conduct Authority with reference number 204440.`
        },
        Section2: {
            Heading: '2. QuickCheck quotation search service',
            Paragraph1: `
                    We provide the QuickCheck quotation service. By using QuickCheck, you confirm that you accept these terms.
                    If you do not agree to these terms, you must not use QuickCheck.
                    We recommend that you print a copy of these terms for future reference.`,
            Paragraph2: `The QuickCheck quotation service includes:`,
            List: {
                Item1: `
                        A pre-application check of your credit record and the information you provide,
                        which we use with our own credit scoring methods to work out and tell you if you are
                        eligible for one of our credit products or not;`,
                Item2: `Confirmation of your eligibility and, where eligible, our credit product suggestions, including by email and/or SMS using the information you provide; and`,
                Item3: `If you do not successfully apply for one of our credit products:`
            },
            SubList: {
                Item1: `where this part of the service is offered with our QuickCheck quotation service, we may do further pre-application checks and let you know whether you're eligible for one of our credit products (unless you tell us you do not want us to do this); and`,
                Item2: `we'll send you marketing about our other suitable products, services or relevant information by post,`
            },
            Paragraph3: `When we make a pre-application check of your credit record and the information you provide, the Credit Reference Agencies will make a record of our searches that will leave a "footprint" on your credit file. You'll be able to see the search on your file, but it won't show up to other organisations. This means there is no impact to your credit rating.`,
            Paragraph4: `Any credit product suggestion(s) we make based on your eligibility is not an offer of credit. While you may apply for a credit product we suggest, that application is subject to fraud, identity and other checks.`
        },
        Section3: {
            Heading: '3. Our Privacy and Cookies Policies',
            Paragraph1: `These terms refer to the following additional terms, which also apply to your use of QuickCheck:`,
            CookiePolicyLink: ExternalLinks.COOKIES,
            PrivacyPolicyLink: ExternalLinks.PRIVACY_POLICY,
            List: {
                Item1: `Our {{PRIVACY_POLICY_LINK}}, which sets out the terms on which we process any personal data we collect from you, or that you provide to us.`,
                Item2: `Our {{COOKIE_POLICY_LINK}}, which sets out information about the cookies on our site.`
            }
        },
        Section4: {
            Heading: '4. Duration of QuickCheck service',
            Paragraph1: `The QuickCheck services will continue unless one of the situations set out below or contrary to these terms occurs:`,
            List: {
                Item1: `You become a customer;`,
                Item2: `We discover your information is no longer up to date;`,
                Item3: `You tell us you no longer wish to use/receive the QuickCheck service; or`,
                Item4: `We no longer store your data (three years after you use QuickCheck).`
            }
        },
        Section5: {
            Heading: '5. Use of QuickCheck services',
            Paragraph1: `You must be over the age of 18 and live in the UK to use QuickCheck.`,
            Paragraph2: `QuickCheck is for your personal use only. You must not use it at any time or in any circumstances for individuals other than yourself.`,
            Paragraph3: `Use of QuickCheck is made available free of charge.`,
            Paragraph4: `We do not guarantee that the QuickCheck service will always be available or be uninterrupted. We may suspend or withdraw or restrict the availability of all or any part of the QuickCheck service for business and operational reasons.`
        },
        Section6: {
            Heading: '6. Intellectual Property',
            Paragraph1: `All copyright, trademarks and all other intellectual property rights in QuickCheck are owned by us.`,
            Paragraph2: `You must not use any part of the content on our site for commercial purposes.`,
            Paragraph3: `You must not modify, adapt, copy, download or post such content or information from the QuickCheck service in any other website or forum.`
        },
        Section7: {
            Heading: '7. Links to QuickCheck',
            Paragraph1: `If you wish to link to the QuickCheck service, please contact us.`
        },
        Section8: {
            Heading: '8. Limitation of liability',
            Paragraph1: `We do not exclude or limit in any way our liability to you where it would be unlawful to do so. This includes liability for death or personal injury caused by our negligence or the negligence of our employees, agents or subcontractors and for fraud or fraudulent misrepresentation.`,
            Paragraph2: `We will not be responsible for loss or damage unless it is foreseeable, i.e. it results because of our negligence or a breach of these terms.`,
            Paragraph3: `We are not responsible for viruses or other malicious or technologically harmful material and any content you download from us is at your own risk. You are responsible for configuring your information technology and you should use your own virus protection software.`,
            Paragraph4: `Our liability for any loss or damage is limited to £100.`
        },
        Section9: {
            Heading: '9. Contact us',
            Paragraph1: `You can contact us using the different ways set out at {{CONTACT_US_LINK}}.`,
            ContactUsLink: ExternalLinks.CONTACT,
            Paragraph2: `If you want to make a complaint, you can write to: Capital One (Europe) plc, PO Box 5281, Nottingham, NG2 3FA. Alternatively, you can find details of how to do it by visiting {{HOMEPAGE_LINK}}. If your complaint is to do with a Credit Reference Agency or the information we have obtained from them, we may direct it to them when it is appropriate to do so.`,
            Paragraph3: `If you're unhappy with how we have dealt with your complaint, you also have the right to complain to the Financial Ombudsman Service by writing to: The Financial Ombudsman Service, Exchange Tower, London E14 9SR. You can also contact them by telephone on 0800 023 4567 or email at {{OMBUDSMAN_EMAIL_LINK}}. You can find further information by visiting {{OMBUDSMAN_LINK}}`
        },
        Section10: {
            Heading: '10. General',
            Paragraph1: `We shall not be liable for any delay or failure to provide the services or perform any obligation under these terms if the delay or failure is caused by circumstances beyond our reasonable control.`,
            Paragraph2: `These terms do not give any rights to anyone who is not a party to them. You may not assign your rights or obligations in relation to these terms.`,
            Paragraph3: `If any provision in these terms becomes invalid or unenforceable the validity or enforceability of the other provisions will not be affected.`,
            Paragraph4: `If there is any delay by us in enforcing any of these terms, this will not be treated as a waiver by us of that or any other provision of these terms.`,
            Paragraph5: `Communications we provide to you by us by email or posted on our site will constitute legal service in writing and will be deemed received by you the day after it is sent or posted.`,
            Paragraph6: `This agreement contains the whole agreement between you and us.`,
            Paragraph7: `These terms and our site are governed by English law. You and we both agree to submit to the exclusive jurisdiction of the English and Welsh courts, unless you're a resident of Northern Ireland where you can also bring proceedings in Northern Ireland, and if you're a resident of Scotland you can also bring proceedings in Scotland.`
        }
    },
    HiddenText: {
        NewTab: ', opens in a new tab',
        NewWindow: ', opens in a new window',
        PopupWindow: ', opens in a popup window',
        CurrentStepReadout: '. Current step.'
    },
    SkipLink: {
        Text: 'Skip to content'
    },
    AboutYou: {
        InterestedInBT: 'Are you interested in transferring a balance?',
        BTAmount: 'How much do you want to transfer?',

        Title: {
            Heading: 'Title'
        },
        FirstName: 'First name',
        LastName: 'Last name',
        DateOfBirth: 'When were you born? (for example, 26 03 2000)',
        EmailAddress: "What's your email address?",
        MobileNumber: {
            Heading: "What's your mobile number?",
            Explanation: "You'll need your mobile phone number to access the app and your online account"
        },
        HomeNumber: "What's your home number?",
        AddHomeNumber: 'Add home number (optional)',
        MarketingPermission:
            'Stay updated about exciting new offers, products, and services. We may get in touch by app, email, text, or post. To say no, untick the box.'
    },
    Employment: {
        Heading: 'Looking good. Next up, tell us about your work and income.',
        EmploymentStatus: {
            Heading: "What's your employment status?"
        },
        Occupation: 'What do you do for work?',
        YearlyIncome: {
            Heading: "What's your yearly income before tax?",
            Description: 'Include your salary, benefits, pensions, and any other money you get on a regular basis.',
            Explanation:
                'If your income could {{BOLD_TEXT}} in the next 12 months, please enter what you think it will be.'
        },
        HouseHoldIncome: {
            Heading: 'Does your household have any other yearly income?',
            Description:
                "This could be your partner's income or anyone with a financial connection to you (like joint bank accounts or mortgages)."
        },
        AdditionalIncome: "What's your other household income?"
    },
    Outgoings: {
        Heading: "You're over halfway. Now for a few details about your outgoings.",
        Dependants: {
            Heading: 'How many people are financially dependent on you?',
            Description:
                'Include children, parents or anyone who relies on you for things like money, clothes or food.',
            Options: { 0: 'None', 1: '1', 2: '2', 3: '3', 4: '4', 99: '5+' }
        },
        CashAdvance: {
            Heading: 'Are you planning to make an immediate withdrawal from a cash machine?'
        },

        ResidentialStatus: {
            Heading: "What's your living situation?",
            Options: {
                PT: 'Private tenant',
                CT: 'Council tenant',
                HO: 'Homeowner',
                LP: 'Living with parents',
                O: 'Other'
            }
        },

        RentMortgagePayments: {
            Heading: "What's your monthly rent or mortgage?",
            Description: "Only enter what you pay yourself, whether that's all or part of the total amount.",
            Explanation:
                'If your rent, mortgage or board could {{BOLD_TEXT}} in the next 12 months, please enter what you think it will be.'
        }
    },
    Address: {
        Heading: 'One last bit of info to go.',
        Title: "What's your address?",
        HouseNumber: 'House number',
        HouseName: 'House/Building name',
        FlatNumber: 'Flat number',
        StreetName: 'Street name',
        AddressLine2: 'Address line 2',
        Town: 'Town/city',
        County: 'County',
        Postcode: 'Postcode',
        HouseFlatNumber: 'House/flat name or number (optional)',
        FindAddressButton: 'Find address',
        LookupAddressLink: 'Or enter address manually',
        SearchAddressLink: 'Or search for your address',
        TimeLived: 'How long have you lived at this address?',

        LookUp: {
            Label: {
                PostCode: 'Postcode',
                PostCodeCurrentAddress: "What's your postcode?",
                PostCodePreviousAddress: 'What was your postcode before this?',
                HouseNumber: 'House/flat name or number (optional)'
            },
            FindAddressButton: 'Find address'
        },
        CurrentAddress: {
            Label: 'Your address',
            ListTitle: 'Select your address',
            TimeAtAddressLabel: 'How long have you lived at this address?'
        },
        PreviousAddress: {
            Label: 'Your previous address',
            ListTitle: 'Select your previous address',
            TimeAtAddressLabel: 'How long did you live at this address?'
        },
        ManualAddressLink: 'Or search for your address',
        LoadingMessage: 'Finding your address...'
    },
    ReasonsToQuoteFooter: {
        Paragraph1:
            "Doing a QuickCheck {{BOLD_TEXT}} and you'll be the only one who can see it on your credit report. We'll also email and text you the results.\n" +
            '\n' +
            'All we do is pass your info to credit reference agencies to do a pre-application check of your credit rating.',
        BoldText: "won't impact your credit score,"
    }
};

export default content;
